module.exports = __webpack_public_path__ + "static/male-female-62388c2148beae56fa758243fa44fc76.svg";